import styled from "styled-components";
const Title = styled.div`
    display: inline-flex;
    white-space: nowrap;
    margin-right: 5px;
    font-size: 14px;
    font-weight: 500;
    line-height: 28px;
    color: #979797;
`;
export default Title


// WEBPACK FOOTER //
// ./src/Ranking/RankCondition/Title.js